import { supabase } from "@/lib/supabase";

/**
 * Soft-delete the current user's profile:
 *   - sets is_deleted=true on the profile
 *   - clears identifying fields so handle is freed up
 *   - signs the user out
 *
 * Event history is intentionally NOT touched — counts and analytics
 * remain accurate. Public consumers already filter is_deleted via RLS
 * and lib/events.js, so the user's events stop appearing for everyone
 * except internal admin views.
 */
export async function softDeleteOwnAccount(userId) {
  if (!userId) throw new Error("Not signed in.");
  const patch = {
    is_deleted: true,
    username: null,      // free the handle so others can claim it
    avatar_url: null,
    bio: null,
    whatsapp: null,
    instagram: null,
    snapchat: null,
  };
  const { error } = await supabase.from("profiles").update(patch).eq("id", userId);
  if (error) throw error;
  // Best-effort: sign out the session locally.
  await supabase.auth.signOut();
  return true;
}
